// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-columns-container {
  margin: 0;
  color: #414651;
}
.custom-columns-container .drag-btn {
  cursor: grab;
}
.custom-columns-btn {
  margin: 0 !important;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/CustomColumnsDropdown/index.less"],"names":[],"mappings":"AACA;EACI,SAAA;EACA,cAAA;ACAJ;ADFA;EAKQ,YAAA;ACAR;ADIA;EACI,oBAAA;ACFJ;AACA,oCAAoC","sourcesContent":["@import (reference) \"../../less/variables.less\";\n.custom-columns-container {\n    margin: 0;\n    color: @secondary-700;\n\n    .drag-btn {\n        cursor: grab;\n    }\n}\n\n.custom-columns-btn {\n    margin: 0 !important;\n}",".custom-columns-container {\n  margin: 0;\n  color: #414651;\n}\n.custom-columns-container .drag-btn {\n  cursor: grab;\n}\n.custom-columns-btn {\n  margin: 0 !important;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
